import { ItemTableConsts } from 'client/util/Constants';

export default {
  props: {
    additionalBulkActions: {
      default: () => [],
      type: Array,
    },
    asidePanelCanceledEventName: {
      default: '',
      type: String,
      required: false,
    },
    boundItemsUrl: {
      default: '',
      type: String,
    },
    bulkActionsList: {
      default: () => [],
      type: Array,
    },
    bulkActionText: {
      default: 'resend email',
      type: String,
    },
    bulkDeleteText: {
      default: 'delete',
      type: String,
    },
    canExport: {
      default: false,
      type: Boolean,
    },
    canModifyColumns: {
      default: false,
      type: Boolean,
    },
    defaultSortField: {
      default: '',
      type: String,
    },
    details: {
      default: false,
      type: Boolean,
    },
    detailsButtonType: {
      default: ItemTableConsts.detailsButtonType.default,
      type: String,
    },
    detailsComponent: {
      default: '',
      type: [String, Object],
    },
    detailsIconLeft: {
      type: Boolean,
      default: false,
    },
    disableBoundCount: {
      default: false,
      type: Boolean,
    },
    disableSearchBar: {
      default: false,
      type: Boolean,
    },
    gettingStartedItemType: String,
    emptyCollectionMessage: {
      default: '',
      type: String,
    },
    idField: {
      default: 'id',
      type: String,
    },
    inDetailsAsidePanel: {
      default: false,
      type: Boolean,
    },
    inPanel: {
      default: true,
      type: Boolean,
    },
    isAsideOpen: {
      default: false,
      type: Boolean,
    },
    keepFresh: {
      default: false,
      type: Boolean,
    },
    legacyRowStyles: {
      default: true,
      type: Boolean,
    },
    linkText: {
      default: '',
      type: String,
    },
    parentOS: {
      default: '',
      type: String,
    },
    // Example: /reports/downloads page
    inSecondaryMainPanel: {
      default: false,
      type: Boolean,
    },
    selectedModelId: {
      default: '',
      type: String,
    },
    selectionItemText: {
      default() {
        return {
          label: 'bound',
          plural: 'items',
          singular: 'item',
        };
      },
      type: Object,
    },
    setGettingStartedTooltipVisibility: {
      default: () => {},
      type: Function,
    },
    setSelectedModelId: {
      default: () => {},
      type: Function,
    },
    showActionBar: {
      default: true,
      type: Boolean,
    },
    showBound: {
      default: true,
      type: Boolean,
    },
    showBoundInitially: {
      default: false,
      type: Boolean,
    },
    showBulkAction: {
      default: false,
      type: Boolean,
    },
    showBulkDelete: {
      default: false,
      type: Boolean,
    },
    showMainAction: {
      default: false,
      type: Boolean,
    },
    showRefreshButton: {
      default: false,
      type: Boolean,
    },
    showSearchForm: {
      default: true,
      type: Boolean,
    },
    showSelection: {
      default: true,
      type: Boolean,
    },
    useDropDownFilterComponent: {
      default: '',
      type: String,
    },
    useSearchContextFilterComponent: {
      default: '',
      type: String,
    },
    useFilterValueComponent: {
      default: '',
      type: String,
    },
    useLargeTableCells: {
      default: false,
      type: Boolean,
    },
    useModernSearchStyles: {
      default: false,
      type: Boolean,
    },
    useMspStyles: {
      default: false,
      type: Boolean,
    },
    viewport: {
      default: null,
      type: Object,
    },
  },
};
